// extracted by mini-css-extract-plugin
module.exports = {"container":"_2-uMuw_sNSOFC4YbjZ2OLK","groupsList":"_2Cvit_YuuR0bdRSJBtTn"};